import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow" }
const _hoisted_2 = { class: "py-8 flex-col-grow" }
const _hoisted_3 = { class: "flex-col-grow items-center" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  key: 0,
  class: "my-6 lg:my-3 flex justify-between"
}
const _hoisted_6 = {
  key: 1,
  class: "h-6 lg:h-3"
}
const _hoisted_7 = { class: "w-full my-1 lg:my-6 flex-col-grow items-center justify-center" }
const _hoisted_8 = { class: "messages-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreditorInfo = _resolveComponent("CreditorInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-image brand-img message-brand" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "fade-in-up",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-center font-medium text-2xl text-base-color-alt" }, " Pago Express ", -1)),
                (_ctx.creditorName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_CreditorInfo, {
                        "creditor-name": _ctx.creditorName,
                        "creditor-tax-id": _ctx.creditorTaxId
                      }, null, 8, ["creditor-name", "creditor-tax-id"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.creditorName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mt-6 mb-10 bg-image lg:mb-8 brand-img-message" }, null, -1)),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: message,
                      class: "text-base-color-alt"
                    }, _toDisplayString(message), 1))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hidden w-full h-16 bg-gray brand-banner" }, null, -1))
  ], 64))
}